/**
 * @param hasDeluxeSample
 * @param isAvailable
 * @param hasFreeSample
 * @param isFullSize
 * @param isMini
 * @returns {string}
 */
export default function getChipLabelUtil ({
  hasDeluxeSample,
  isAvailable,
  hasFreeSample,
  isFullSize,
  isMini
}) {
  if (!isAvailable) {
    return 'Out of Stock'
  }

  if (hasDeluxeSample) {
    return 'Deluxe Sample'
  }

  if (hasFreeSample) {
    return 'Free Sample'
  }

  if (isMini) {
    return 'Mini'
  }

  if (isFullSize) {
    return 'Full size'
  }

  return ''
}
